export default {"src":"/_next/static/media/radishes.c99b4d12.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};